module.exports = __webpack_public_path__ + "media/images/powerpoint/sncf-ter-29b2b61721f0b1b6d58f1fc4ba424725.png";